export default {
  en: {
    load_more_button_text: "Load more",
    error_state_no_events: "There are no events available at the moment.",
    generic_error: "Oops, something went wrong",
    pupil_tag: "Pupil",
    student_tag: "Student",
    porfessional_tag: "Professional",
  },
  de: {
    pupil_tag: "Schüler:innen",
    student_tag: "Studierende",
    porfessional_tag: "Berufserfahrene",
    load_more_button_text: "Mehr laden",
    error_state_no_events: "Es sind gerade keine Events verfügbar.",
    generic_error: "Da ist was schief gelaufen.",
  },
};
